export default {"src":"https://assets.madeeasy.in/non-prod/_next/static/media/noCourse.d50b1cbd.svg","height":115,"width":141,"blurWidth":0,"blurHeight":0};